export default "__VITE_ASSET__0Q$GBGHG__"